export default __webpack_public_path__ + "static/media/thankYou.76052504.png";